import { RootState } from 'store/types';

export const sessionSelector = (state: RootState) => state.session;
